import { Action } from '@ngrx/store';

export enum ClientActionsTypes {
  LoadClients = '[Clients] Load clients',
  LoadClientsSuccess = '[Clients] Load clients success',

  LoadClientFormTemplates = '[Clients] Load Form Templates',
  LoadClientFormTemplatesSuccess = '[Clients] Load form femplates success',
}

export class LoadClients implements Action {
  readonly type = ClientActionsTypes.LoadClients;
}

export class LoadClientsSuccess implements Action {
  readonly type = ClientActionsTypes.LoadClientsSuccess;
  constructor(public payload: any) {}
}

export class LoadClientFormTemplates implements Action {
  readonly type = ClientActionsTypes.LoadClientFormTemplates;
}

export class LoadClientFormTemplatesSuccess implements Action {
  readonly type = ClientActionsTypes.LoadClientFormTemplatesSuccess;
  constructor(public payload: any) {}
}

export type ClientActions =
  | LoadClients
  | LoadClientsSuccess
  | LoadClientFormTemplates
  | LoadClientFormTemplatesSuccess;
